import { FC, useEffect } from 'react';
import CustomersProfilesHeader from './containers/CustomersProfilesHeader/CustomersProfilesHeader';
import CustomersProfilesList from './containers/CustomersProfilesList/CustomersProfilesList';
import { customersProfilesStore } from './store';

const CustomersProfilesScreen: FC = (): JSX.Element => {
  useEffect(() => {
    return () => customersProfilesStore.clearFilters();
  }, []);

  return (
    <>
      <CustomersProfilesHeader />
      <CustomersProfilesList />
    </>
  );
};

export default CustomersProfilesScreen;
